// service
import React from "react";
import {
  Briefcase,
  ClipboardList,
  BarChart3,
  Binoculars,
  Sun,
  CalendarDays,
} from "lucide-react";
import bg from "./bg1.jpg";

function Service() {
  return (
    <section
      id="services"
         className="pt-32 min-h-screen w-full text-white flex flex-col items-center px-6 py-12 bg-cover bg-center" style={{ backgroundImage: `url(${bg})` }}
    >
      {/* Tilt Background Layer */}
      <div className="absolute inset-0 top-16 bottom-16  -skew-y-3"></div>

      {/* Section Title */}
      <div
        className="relative max-w-3xl mx-auto text-center mb-16"
        data-aos="fade-up"
      >
         <h1 className="text-4xl md:text-6xl font-bold text-cyan-300 bg-clip-text">
          SERVICES
        </h1>
        <p className="text-gray-300 text-xl mt-2">
         We offer end-to-end digital and cybersecurity solutions designed to support modern business transformation needs.


        </p>
      </div>

      {/* Services Grid */}
      <div className="relative container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-8">

          {/* Service 1 */}
          <ServiceCard
            delay="100"
            // icon={<Briefcase className="w-10 h-10 text-[#e03a3c]" />}
            title="🌐 Cyber Security Solutions
"
            desc="Advanced threat protection, penetration testing, vulnerability assessment, cybersecurity audits, and digital risk monitoring to safeguard your systems from cyber-attacks.
"
          />

          {/* Service 2 */}
          <ServiceCard
            delay="200"
            // icon={<ClipboardList className="w-10 h-10 text-[#e03a3c]" />}
            title="💻 Web Development"
            desc="Professional websites, dashboards, CRM/ERP systems, online platforms, and custom web applications using modern UI/UX and optimized performance.
"
          />

          {/* Service 3 */}
          <ServiceCard
            delay="300"
            // icon={<BarChart3 className="w-10 h-10 text-[#e03a3c]" />}
            title="📱 Mobile App Development
"
            desc="Android & iOS application development with seamless performance, secure architecture, and real-time integration.
"
          />

          {/* Service 4 */}
          <ServiceCard
            delay="400"
            // icon={<Binoculars className="w-10 h-10 text-[#e03a3c]" />}
            title="🤖 AI & Automation"
            desc="AI-powered automation, machine learning models, predictive analytics & workflow optimization for smarter business operations.
"
          />

          {/* Service 5 */}
          <ServiceCard
            delay="500"
            // icon={<Sun className="w-10 h-10 text-[#e03a3c]" />}
            title="☁ Cloud Solutions
"
            desc="Cloud migration, cloud computing infrastructure, deployment, resource management, and disaster recovery with AWS / Azure / Google Cloud.
"
          />

          {/* Service 6 */}
          <ServiceCard
            delay="600"
            // icon={<CalendarDays className="w-10 h-10 text-[#e03a3c]" />}
            title="🛡 Network Security
"
            desc="Firewall infrastructure, intrusion detection, network audits & secure networking setups for small to large organizations.
"
          />
          <ServiceCard
            delay="600"
            // icon={<CalendarDays className="w-10 h-10 text-[#e03a3c]" />}
            title="🖥 IT Infrastructure Management

"
            desc="Server installation, hardware configuration, data center management & enterprise technical setups with full deployment support.


"
          />
          <ServiceCard
            delay="600"
            // icon={<CalendarDays className="w-10 h-10 text-[#e03a3c]" />}
            title="
🔍 Digital Forensics & Investigation

"
            desc="Cybercrime evidence collection, data recovery, forensic reporting & support for legal processes and compliance.



"
          />
          <ServiceCard
            delay="600"
            // icon={<CalendarDays className="w-10 h-10 text-[#e03a3c]" />}
            title="📞 24/7 Technical Support

"
            desc="Dedicated remote + on-site IT support for uninterrupted business continuity and zero downtime.

"
          />
          <ServiceCard
            delay="600"
            // icon={<CalendarDays className="w-10 h-10 text-[#e03a3c]" />}
            title="📊 Software & Business Consulting

"
            desc="Technology strategy, digital transformation consulting, IT planning, architecture design & growth-focused technology guidance.
"
          />
        </div>
      </div>
    </section>
  );
}

/* ---------------------------
   REUSABLE SERVICE CARD  
---------------------------- */
function ServiceCard({ delay, icon, title, desc }) {
  return (
    <div data-aos="fade-up" data-aos-delay={delay}>
      <div className="flex gap-6 p-8 bg-white/10 backdrop-blur-lg rounded-xl border border-white/10 hover:bg-white/20 transition h-full">
        {icon}
        <div>
          <h4 className="text-xl font-bold mb-3">
            <a
              href="/service-details"
              className="text-white hover:text-[#e03a3c] duration-300"
            >
              {title}
            </a>
          </h4>
          <p className="text-gray-300 text-sm leading-relaxed">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default Service;
